import PrivateNetworkClient from "helpers/privateNetwork";

const getUserList = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/getUserList", formData);
  return data;
};

const addUser = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/createUser", formData);
  return data;
};

const editUser = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/editUser", formData);
  return data;
};

const deleteUser = async (id) => {
  const { data } = await PrivateNetworkClient.delete(`/deleteUser/${id}`);
  return data;
};

const getAllRoles = async () => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get("/get_all_roles");
  return data;
};

const statusUser = async (id) => {
  // if(localStorage.getItem('token') === null) {
  //   return null;
  // }
  const { data } = await PrivateNetworkClient.put(`/user/changeStatus/${id}`);
  return data;
}

export {
  getUserList,
  addUser,
  editUser,
  deleteUser,
  getAllRoles,
  statusUser
};
